import React from "react"
import { IconPlayerPlay } from "@tabler/icons-react"
import useSound from "use-sound"
import Button from "@love-irish/core-button"
import Tooltip from "design_system/core/components/tooltip"
import tadhgAvatar from "images/profile_icons/tadhg.png"

interface AudioPlayerProps {
  audioUrl: string
  showDetailedPlayer?: boolean
}

export const AudioPlayer: React.FC<AudioPlayerProps> = ({
  audioUrl,
  showDetailedPlayer = false,
}) => {
  const [play] = useSound(audioUrl)

  const handlePlay = (e: React.MouseEvent) => {
    e.stopPropagation()
    play()
  }

  if (showDetailedPlayer) {
    return (
      <div className="p-2">
        <div className="flex justify-start gap-2 bg-earth-50/70 text-earth-800 p-2 rounded border border-earth-200 items-center">
          <img loading="lazy" src={tadhgAvatar} className="w-[32px] pixel-art" alt="" />
          <button
            aria-label="Play audio"
            className="bg-none! cursor-pointer"
            onClick={handlePlay}
            type="button"
          >
            <IconPlayerPlay size={24} className="inline-block" />
          </button>
          <p>
            Featured community recording from{" "}
            <a href="/@tadhg" className="font-bold">
              @tadhg
            </a>
          </p>
        </div>
      </div>
    )
  }

  return (
    <Tooltip title="Play featured community recording">
      <Button size="sm" variant="ghost" onClick={handlePlay}>
        <IconPlayerPlay size={16} className="inline-block" />
      </Button>
    </Tooltip>
  )
}

export default AudioPlayer
